<template>
    <div>
        <div class="flex flex-col center">
            <div class="center">
                <h2 class="text-4xl mb-4 font-black">Payment Declined!</h2>
            </div>
        </div>
    </div>
</template>

<script>

    import sendToVend from './../js/vendMessages'

    export default {
        name: 'PaymentFailed',
        data() {
            return {

            }
        },
        created() {
            setTimeout(()=> {
                this.closeWindow();
            },100);
        },
        methods: {
            closeWindow() {
                sendToVend("DECLINE")
            }
        }
    }

</script>

<style>


</style>
